import { Auth } from 'aws-amplify';

import type { AuthHeader } from '../interfaces';

/**
 * Bearer JWT headers for admin routes behind the JWT API Gateway authorizer.
 * Cognito IAM signing (default Amplify REST) is rejected on these paths.
 */
const getAdminJwtAuthHeaders = async (): Promise<Partial<AuthHeader>> => {
    try {
        const session = await Auth.currentSession();
        const idToken = session.getIdToken();
        const sub = idToken.payload?.sub;
        const jwt = idToken.getJwtToken();
        if (sub && jwt) {
            return {
                Authorization: `Bearer ${jwt}`,
                SpecterxUserId: sub,
            };
        }
    } catch {
        // No session — caller will get a 401 from the API.
    }
    return {};
};

export default getAdminJwtAuthHeaders;
